<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-6"></a>
<h2 class="cpp20"><span class="cpp8">Acknowledgements</span></h2>
<p class="cpp23er"><span class="drop-cap">I</span><span class="cpp10">n compiling this book I have received help and support from many people. Although they are far too numerous to mention in full, I would specifically like to thank the following:</span></p>
<p class="cpp24"><span class="cpp10">Rachel Conroy, Curator of Temple Newsam House; Kitty Ross, Curator of the Abbey House Museum; Lucy Moore, Projects Curator for Leeds Museums; Lord Halifax; Julie Holroyd and Adrian Thompson, Visitor Assistants at Temple Newsam House; Derek Voller; Lis Burke; Neil Clifton; Richard Thomson; David Pacey; The West Yorkshire Archive Service; The Borthwick Institute; The Thoresby Society; Imperial War Museums, London; The British Red Cross Archives; The Shakespeare Birthplace Trust Archives; The Leeds Library; The Royal Archives; Heritage Technology Ltd; members of the general public and, of course, my wife Linda – for her endless patience.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Chapter_1.vue?7048d544